"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = __importDefault(require("atomicComponents/atoms/Icons/Icon"));
var ModalIcon = function (_a) {
    var color = _a.color, icon = _a.icon, imgAlt = _a.imgAlt;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [typeof icon === 'string' && (0, jsx_runtime_1.jsx)("img", { src: icon, alt: imgAlt, height: "64", width: "64" }), typeof icon === 'object' && (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: icon, size: "4x", color: color })] }));
};
exports.default = ModalIcon;
